<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="d-flex">
    <app-go-back [marginClass]="''"></app-go-back>
    <h1 class="h2 text-info mx-4">{{ 'clusters.list.title' | translate }}</h1>
  </div>
  <!-- <app-is-guarded [permissions]="['CAN_CREATE_CLUSTER']">
    <a class="btn btn-info btn-sm text-sm text-white fw-bold mx-3" (click)="openCreateModal()">Nouveau clusteur</a>
  </app-is-guarded> -->
</div>

<div>
  <app-table *ngIf="clusters$ | async as clusters" [columnDefs]="columnDefs" [tableData]="clusters"
    (actionInvoqueFunctionEvent)="tableActionsFunction($event)"></app-table>
  <ng-template [ngIf]="!(clusters$ | async)?.length">
    <app-empty-card [icon]="'exclamation-circle'" [message]="'clusters.list.emptyMessage' | translate"></app-empty-card>
  </ng-template>
  <app-pagination
    *ngIf="(clusters$ | async)?.length" 
    [pagination]="pagination" 
    (paginationEvent)="paginate($event)">
  </app-pagination>
</div>

<modal #nGmodal [modalConfig]="modalConfig" class="modal-dialog-centered">
  <form *ngIf="modalFormType === 'CREATE' || modalFormType === 'UPDATE'" [formGroup]="modalForm">
    <div class="mb-3">
      <label for="country_id" class="form-label fw-bold text-secondary">{{ 'clusters.list.form.countryLabel' | translate }}
      </label>
      <select formControlName="country_id" class="form-control form-control-sm" [attr.aria-label]="'clusters.list.form.countryAriaLabel' | translate">
        <option [ngValue]="undefined" selected>{{ 'clusters.list.form.countryPlaceholder' | translate }}</option>
        <option *ngFor="let country of countries$ | async" [ngValue]="country.id">
          {{ country.name }}
        </option>
      </select>
    </div>
    <div class="mb-3">
      <label for="libelle" class="form-label fw-bold text-secondary">{{ 'clusters.list.form.labelFr' | translate }}
      </label>
      <input type="text" id="libelle" class="form-control" formControlName="cluster" />
    </div>
    <div class="mb-3">
      <label for="libelle" class="form-label fw-bold text-secondary">{{ 'clusters.list.form.labelEn' | translate }}
      </label>
      <input type="text" id="libelle" class="form-control" formControlName="cluster_en" />
    </div>
    <div class="mb-3">
      <label for="libelle" class="form-label fw-bold text-secondary">{{ 'clusters.list.form.passageLabel' | translate }}
      </label>
      <input type="number" [min]="1" id="libelle" class="form-control" formControlName="passage" />
    </div>
    <div class="d-flex mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="flexCheckDefault" formControlName="activate" />
        <label class="form-check-label fw-bold text-secondary" for="flexCheckDefault">
          {{ 'clusters.list.form.statusLabel' | translate }}
        </label>
      </div>
    </div>
  </form>
  <p></p>
  <p *ngIf="modalFormType === 'DELETE'">
    <strong>{{ 'clusters.list.confirm.deleteMessagePrefix' | translate }}
      <span class="text-danger">"{{ currentCluster.cluster }}"</span>?</strong>
  </p>
  <p class="mt-4" *ngIf="!modalFormDisplay && modalFormStatusActionMessage">
    {{ modalFormStatusActionMessage }}
  </p>
</modal>